import i18next from 'data/i18next';
import { Locale, Replace } from 'types/locales';

const parseKey = (key: string) => {
  const [ns, ...paths] = key.split('.');

  return [ns, paths.join('.')];
};

const has = (key: string) => {
  const [ns, path] = parseKey(key);

  return i18next.exists(path, { ns });
};

const get = (key: string, replace?: Replace) => {
  const [ns, path] = parseKey(key);

  return i18next.t(path, { ns, replace });
};

const choice = (key: string, count: number, replace?: Replace) => {
  const [ns, path] = parseKey(key);

  return i18next.t(path, { ns, count, replace });
};

const getLocale = () => {
  return i18next.language as Locale;
};

const changeLocale = async (locale: Locale) => {
  await i18next.changeLanguage(locale);
};

const lang = {
  parseKey,
  has,
  get,
  choice,
  getLocale,
  changeLocale,
};

export default lang;
